/**
 * StreamingSetupDialog — instructions + copyable URL for OBS Browser Source.
 */
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Monitor, Copy } from "lucide-react";

export default function StreamingSetupDialog({ t, open, onOpenChange }) {
  const streamUrl = typeof window !== "undefined" ? `${window.location.origin}/stream-output` : "";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Monitor className="w-5 h-5 text-red-500" />
            {t("live_streaming_setup") || "Live Streaming Setup"}
          </DialogTitle>
          <DialogDescription>{t("stream_to_obs_desc") || "Stream your presentation to OBS or other platforms"}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="p-4 bg-slate-50 dark:bg-slate-900 rounded-lg space-y-3">
            <h4 className="font-medium">{t("stream_output_url") || "Stream Output URL"}</h4>
            <div className="flex gap-2">
              <Input value={streamUrl} readOnly className="font-mono text-sm" />
              <Button
                variant="outline"
                onClick={() => {
                  navigator.clipboard.writeText(streamUrl);
                  toast.success(t("url_copied") || "URL copied!");
                }}
              >
                <Copy className="w-4 h-4" />
              </Button>
            </div>
            <p className="text-xs text-muted-foreground">Add this URL as a Browser Source in OBS</p>
          </div>
          <div className="space-y-2 text-sm">
            <h4 className="font-medium">Quick Setup:</h4>
            <ol className="list-decimal list-inside space-y-1 text-muted-foreground">
              <li>Open OBS Studio</li>
              <li>Add a Browser Source</li>
              <li>Paste the URL above</li>
              <li>Set resolution to 1920x1080</li>
              <li>Start presenting in SlideCon</li>
            </ol>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Close</Button>
          <Button onClick={() => window.open("/stream-output", "_blank")}>
            Open Preview
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
